import React, { useEffect, useState } from "react";
import momentPropTypes from "react-moment-proptypes";
import PropTypes from "prop-types";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const FieldDatePicker = (props) => {
  const {
    format = "DD MMMM YYYY",
    disabled,
    date,
    focused,
    onFocusChange,
    onDateChange,
    small,
    block,
    noBorder,
    placeholder = "Tanggal",
    id,
    className,
    popperPlacement,
  } = props;
  const zIndex = props["z-index"];

  const [value, setValue] = useState(date);
  const [open, setOpen] = useState(false);
  const isControlled = typeof focused === "boolean";

  useEffect(() => {
    setValue(date);
  }, [date]);

  useEffect(() => {
    if (isControlled) {
      setOpen(focused);
    }
  }, [focused, isControlled]);

  const handleChange = (newValue) => {
    setValue(newValue);
    onDateChange(newValue);
  };

  const handleOpen = () => {
    if (!isControlled) {
      setOpen(true);
    }
    onFocusChange && onFocusChange({ focused: true });
  };

  const handleClose = () => {
    if (!isControlled) {
      setOpen(false);
    }
    onFocusChange && onFocusChange({ focused: false });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <div
        className={`datepicker-container ${className ? className : ""}`}
        style={zIndex ? { position: "relative", zIndex } : undefined}
      >
        <DatePicker
          value={value}
          onChange={handleChange}
          format={format}
          disabled={disabled}
          open={open}
          onOpen={handleOpen}
          onClose={handleClose}
          slotProps={{
            textField: {
              size: small ? "small" : "medium",
              variant: noBorder ? "standard" : "outlined",
              fullWidth: block,
              placeholder,
              id,
            },
            popper: popperPlacement ? { placement: popperPlacement } : undefined,
            actionBar: { actions: ["clear"] },
          }}
        />
      </div>
    </LocalizationProvider>
  );
};

FieldDatePicker.propTypes = {
  onDateChange: PropTypes.func.isRequired,
  date: momentPropTypes.momentObj || null,
  focused: PropTypes.bool,
  onFocusChange: PropTypes.func,
};

export default FieldDatePicker;
